export const ApplicationConstant = {
    ApplicationID :27 ,
    clientId : 16,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
